import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { sendContactFrom } from '../services/contactFormService';

interface ContactFormData {
    name: string;
    email: string;
    message: string;
}

interface ContactState {
    isSubmitting: boolean;
    lastSubmitStatus: 'success' | 'error' | null;
    error: string | null;
}

const initialState: ContactState = {
    isSubmitting: false,
    lastSubmitStatus: null,
    error: null
};

export const sendContactForm = createAsyncThunk(
    'contact/sendForm',
    async (formData: ContactFormData) => {
        await sendContactFrom(formData);
        return { success: true };
    }
);

const contactSlice = createSlice({
    name: 'contact',
    initialState,
    reducers: {
        clearStatus: (state) => {
            state.lastSubmitStatus = null;
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(sendContactForm.pending, (state) => {
                state.isSubmitting = true;
                state.lastSubmitStatus = null;
                state.error = null;
            })
            .addCase(sendContactForm.fulfilled, (state) => {
                state.isSubmitting = false;
                state.lastSubmitStatus = 'success';
                state.error = null;
            })
            .addCase(sendContactForm.rejected, (state, action) => {
                state.isSubmitting = false;
                state.lastSubmitStatus = 'error';
                state.error = action.error.message || 'Failed to send message';
            });
    }
});

export const { clearStatus } = contactSlice.actions;
export default contactSlice.reducer;